import React, {useState} from 'react';
import {get} from 'lodash';
import className from 'classnames';
import moment from 'moment';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import {
  canKenta,
  canManage
} from '../lib/policies';

import {useCheckIds} from '../hooks';

import ImageLoader from './ImageLoader';
import OverflowH from './OverflowH';
import DotTooltip from './DotTooltip';
import Loading from './Loading';
import Clipboard from './Clipboard';
import UuidLogin from './UuidLogin';
import UsersSameUUIDListPenaltyTools from './UsersSameUUIDListPenaltyTools';

const UsersSameUUIDList = ({
  posts = [],
  uuid,
  userId,
}) => {
  const {
    checkIds,
    setCheckIds,
    renderCheckBox,
  } = useCheckIds({
    data: posts,
    openUrl: 'posts',
  })

  const [users, usersSet] = useState({
    shouldFetch: true,
    data: [],
  })

  const [allowUuidLogin, allowUuidLoginSet] = useState(false)

  const _fetchData = () => {
    if (uuid && users.shouldFetch) {
      fetchUsers()
      fetchSharedSetting()
    }
  }

  const fetchUsers = () => {
    axios.get(`/${gon.currentProvider}/api/users`, {
      params: {
        uuid,
      },
    })
      .then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          usersSet({
            shouldFetch: false,
            data: get(res, 'data.users'),
          })
        }
      })
  }

  const fetchSharedSetting = () => {
    if (gon.currentProvider == "yay") {
      axios.get(`/${gon.currentProvider}/api/shared_settings/${userId}`)
        .then((res) => {
          if (res.status == 200 && get(res, 'data')) {
            allowUuidLoginSet(get(res, 'data.allowUuidLogin'))
          }
        })
        .catch(function (error) {
          allowUuidLoginSet(false)
        })
    }
  }

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3'>User same UUID list</h3>
      </div>

      <div className='TableChecker TableChecker--ban'>
        {canKenta('User') &&
          <div className='TableChecker__left'>
            <div
              className='TableChecker__left__a'
            >
              <a
                onClick={() => {
                  if (checkIds.length < get(users, 'data.length', 0)) {
                    setCheckIds(get(users, 'data', []).map((x) => x.id))
                  }
                  else {
                    setCheckIds([])
                  }
                }}
                className={className('CheckBox', {
                  'CheckBox--partial': checkIds.length > 0,
                  'CheckBox--active': checkIds.length == get(users, 'data.length'),
                })}
              />

              <UsersSameUUIDListPenaltyTools
                userIds={checkIds}
                uuid={uuid}
              />
            </div>
          </div>
        }

        <div className='TableChecker__uuid'>
          <strong>UUID:</strong>

          {uuid}

          <div className='TableChecker__uuid__actions'>
            <Clipboard
              value={uuid}
            />
            {canManage('User') && gon.currentProvider == "yay" &&
              <UuidLogin
                userId={userId}
                allowUuidLogin={allowUuidLogin}
              />
            }
          </div>
        </div>
      </div>


      <Waypoint onEnter={_fetchData}>
        <div className='Table Table--users-same-uuid-list'>
          {(() => {
            const columnHeaders = [
              '', 'ID', 'Nickname', 'Bio', 'Last login',
              'Photo', 'Status',
            ]

            return (
              <div className='Table__row'>
                {columnHeaders.map((value, key) => (
                  <div
                    key={key}
                    className='Table__col Table__col--th'
                  >
                    {value}
                  </div>
                ))}
              </div>
            )
          })()}

          <Loading
            isLoading={get(users, 'shouldFetch')}
          >
            {get(users, 'data', []).map((user) => (
              <div
                className={className('Table__row', {
                  'Table__row--active': checkIds.includes(user.id),
                })}
                key={user.id}
              >
                <div className='Table__col'>
                  {renderCheckBox(user)}
                </div>

                <div className='Table__col'>
                  <DotTooltip
                    user={user}
                  />
                </div>

                <div className='Table__col'>
                  {user.nickname}
                  {userId === user.id && ' (this account)'}
                </div>

                <div className='Table__col'>
                  <OverflowH
                    text={user.biography}
                  />
                </div>

                <div
                  className='Table__col'
                  dangerouslySetInnerHTML={
                    {
                      __html: user.lastLoggedinAt !== null ?
                        moment(user.lastLoggedinAt).format('YYYY-MM-DD<br />HH:mm')
                      :
                        'N/A'
                    }
                  }
                />

                <div className='Table__col'>
                  <div className='ImageBorder'>
                    <ImageLoader
                      url={get(user, 'profileIcon.thumb.url')}
                    />
                  </div>
                </div>

                <div className='Table__col'>
                  {user.isBanned ?
                    <span className='Badge Badge--orange'>Temp banned</span>
                  :
                    <span className='Badge'>Active</span>
                  }
                </div>
              </div>
            ))}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  );
}

export default UsersSameUUIDList;
